import React from 'react';

import useScreenOrientation from './helpers/useScreenOrientation';
import iconScore from "../assets/images/Icon_Star.png";

export default function Score({ isVisible, setView, userScoreUI, userTimeUI }: any) {

  const isLandscape = useScreenOrientation();

  const showTopResults = () => {
    setView("TopResults")
  };

  const showExit = () => {
    setView("Intro")
  };

  return (
    <div className={`full-score-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`score-container ${isLandscape ? '' : 'portrait'}`}>

        <div className={`score-title ${isLandscape ? '' : 'portrait'}`}>Tu puntaje</div>

        <div className={`score-container-grid ${isLandscape ? '' : 'portrait'}`}>
          <div className="score-stats-container-item">
            <div className="score-stats-item-icon"><img className={`score-stats-item-icon-img ${isLandscape ? '' : 'portrait'}`} src={iconScore} alt=''/></div>
            <div className="score-stats-item-text-container">
              <div className={`score-stats-item-text-value ${isLandscape ? '' : 'portrait'}`}>{userScoreUI}</div>
              <div className={`score-stats-item-text-title ${isLandscape ? '' : 'portrait'}`}>Puntos</div>
            </div>
          </div>
        </div>

        <div className="score-buttons">
          <div className="score-button-container" onClick={() => showTopResults()} >
            <div className={`score-button-text ${isLandscape ? '' : 'portrait'}`}>Ver Top</div>
          </div>
          <div className="score-button-container exit" onClick={() => showExit()} >
            <div className={`score-button-text exit ${isLandscape ? '' : 'portrait'}`}>Salir</div>
          </div>
        </div>

      </div>
    </div>
  );
}